<template>
  <main>
  <v-app class="pa-0" :class="{ mobile: isMobile, dark: isDarkTheme }">
    <div style="min-height: 100vh; width: 100vw; z-index: 2">
      <RouterView />
    </div>

    <ErrorDisplayVue :showErrorDisplay="showErrorDisplay" :errorMessage="errorMessage" :status="status"
      :additionalMessage="additionalMessage" />

    <SaveDisplayVue :showSaveDisplay="showSaveDisplay" />
    <CopiedDisplayVue :showCopiedDisplay="showCopiedDisplay" />

    <FooterVue />
  </v-app>
  </main>
</template>

<script>
import { useTheme } from "vuetify";

import ErrorDisplayVue from "./components/main/ErrorDisplay.vue";
import FooterVue from "./components/navigation/Footer.vue";

import SaveDisplayVue from "./components/main/SaveDisplay.vue";
import CopiedDisplayVue from "./components/main/CopiedDisplay.vue";

export default {
  name: "app",

  data() {
    return {
      showErrorDisplay: 0,
      errorMessage: undefined,
      additionalMessage: undefined,
      status: undefined,

      showSaveDisplay: 0,
      showCopiedDisplay: 0,
    };
  },

  components: {
    FooterVue,
    ErrorDisplayVue,
    SaveDisplayVue,
    CopiedDisplayVue,
  },

  computed: {
    isDarkTheme() {
      return this.$vuetify.theme.global.current.dark;
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
  },

  watch: {
    "$route.path"() {
      if (!this.$route.path || !this.$store.state.avail_routes) {
        return
      }

      window.scrollTo(0, 0);
      if (this.$route.path.startsWith("/main/") && !this.$store.state.avail_routes.includes("main")) {
        this.$router.push("/backoffice/dashboard")
        window.reload()
      }
      if (this.$route.path.startsWith("/backoffice/") && !this.$store.state.avail_routes.includes("backoffice")) {
        this.$router.push("/main/dashboard")
        window.reload()
      }
    },
  },

  methods: {
    checkRefreshToken() {
      const token = this.$store.state.refreshToken;
      if (!token) return;

      try {
        const payload = token.split(".")[1];
        const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
        const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
        const { exp } = JSON.parse(atob(padded));

        if (!Number.isFinite(exp) || exp * 1000 < Date.now() + 4 * 60 * 60 * 1000) {
          console.log("expired!")
          this.$router.replace("/login");
        }
      } catch {
        this.$router.replace("/login");
      }
    },
  },

  mounted() {
    window.addEventListener("showErrorDisplay", (value) => {
      if(this.$route.path.includes("login") && value.detail.code == 401){
        return
      }

      this.errorMessage = value.detail.code + ", " + value.detail.message;

      try {
        this.additionalMessage = value.detail?.response?.data;
      } catch (e) {
        console.log(e);
        this.additionalMessage = "";
      }

      try {
        this.status = value.detail.response.status;
      } catch (e) {
        this.status = undefined;
      }

      this.showErrorDisplay++;
    });

    window.addEventListener("showSaveDisplay", (value) => {
      this.showSaveDisplay++;
    });

    window.addEventListener("showCopiedDisplay", (value) => {
      this.showCopiedDisplay++;
    });

    //set theme
    const theme = this.$store.state.theme;
    // Public pages use the custom light palette even with a saved dark preference.
    if (this.$route.meta?.seoPublic === true) {
      useTheme().global.name.value = "customLightTheme";
    } else if (theme) {
      useTheme().global.name.value = theme;
    }

    this.checkRefreshToken()
    // const lastLogin = this.$store.state.lastLogin;
    // const now = Date.now();
    // const hoursElapsed = (now - lastLogin) / (1000 * 60 * 60); // ms → hours

    // if ((lastLogin == null || hoursElapsed > 20) && this.$route.path != "/") {
    //   this.$router.push("/?next=" + btoa(this.$route.path)); // adjust route name if needed
    // }
  },
};
</script>
